import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import { MasterDataType } from "./masterTypes";
import {
  checkUniqueBranchNameAction,
  checkUniqueClientGroupNameAction,
  checkUniqueCode,
  checkUniquePdfTemplateNameAction,
  createMasterClientGroupAction,
  createMasterDataActivityCodeAction,
  createMasterDataBranchAction,
  createMasterDataClientCategoryAction,
  createMasterDataCurrencyAction,
  createMasterDataQualificationModuleAction,
  createMasterDataScopeOfWorkAction,
  createMasterDataSkillsModuleAction,
  createMasterDataUsersDepartmentAction,
  createMasterEmailersAction,
  createMasterHolidayCalenderAction,
  createMasterPdfTemplateAction,
  createMasterTcsModuleAction,
  createMasterTdsModuleAction,
  deleteHolidayCalenderAction,
  deleteMasterDataQualificationAction,
  deleteMasterDataScopeOfWorkAction,
  deleteMasterDataSkillsAction,
  deleteMasterDataUsersDepartmentAction,
  deleteMasterPdfTemplateAction,
  deleteMasterTcsModuleAction,
  deleteMasterTdsModuleAction,
  getAllCityAction,
  getAllCityPermanentAddressAction,
  getAllCountryAction,
  getAllMasterDataActivityCodeAction,
  getAllMasterDataBranchAction,
  getAllMasterDataCurrencyAction,
  getAllStateAction,
  getAllStatePermanentAddressAction,
  getCurrencyExchangeAction,
  getMasterDataActivityCodeAction,
  getMasterDataBranchAction,
  getMasterDataClientCategoryAction,
  getMasterDataClientGroupAction,
  getMasterDataCurrencyAction,
  getMasterDataEmailersAction,
  getMasterDataHolidayCalenderAction,
  getMasterDataQualificationModuleAction,
  getMasterDataScopeOfWorkAction,
  getMasterDataSkillsModuleAction,
  getMasterDataUsersDepartmentAction,
  getMasterPdfTemplateListAction,
  getMasterTcsModuleAction,
  getMasterTcsModuleSingleAction,
  getMasterTdsModuleAction,
  getMasterTdsModuleSingleAction,
  updateMasterDataActivityCodeAction,
  updateMasterDataBranchAction,
  updateMasterDataClientCategoryAction,
  updateMasterDataClientGroupAction,
  updateMasterDataCurrencyAction,
  updateMasterDataEmailersAction,
  updateMasterDataHolidayCalenderAction,
  updateMasterDataQualificationModuleAction,
  updateMasterDataScopeOfWorkAction,
  updateMasterDataSkillsModuleAction,
  updateMasterDataUsersDepartmentAction,
  updateMasterPdfTemplateAction,
  updateMasterTcsModuleAction,
  updateMasterTdsModuleAction,
} from "./actions";
import { masterReducer } from "./reducer";

export const masterDataSlice = createSlice({
  name: "masterData",
  initialState,
  reducers: masterReducer,
  extraReducers: {
    [createMasterDataBranchAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [createMasterDataBranchAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message, result } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [createMasterDataBranchAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [getMasterDataBranchAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getMasterDataBranchAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        masterDataListing: result,
        success,
      };
    },
    [getMasterDataBranchAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    [checkUniqueBranchNameAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      branchFetching: true,
    }),
    [checkUniqueBranchNameAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, is_exist, message, status_code } = payload?.data;

      if (success === 0) {
        return {
          ...state,
          branchSuccess: success,
          branchFetching: false,
          branchError: message,
          branchSatusCode: status_code,
          isBranchName: is_exist,
        };
      }
      return {
        ...state,
        isBranchName: is_exist,
        branchFetching: false,
        branchMessage: message,
        branchSatusCode: status_code,
        branchSuccess: success,
      };
    },
    [checkUniqueBranchNameAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      branchFetching: false,
      branchSuccess: 0,
      error: error?.message,
    }),
    [checkUniquePdfTemplateNameAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      branchFetching: true,
    }),
    [checkUniquePdfTemplateNameAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, is_exist, message, status_code } = payload?.data;

      if (success === 0) {
        return {
          ...state,
          branchSuccess: success,
          branchFetching: false,
          branchError: message,
          branchSatusCode: status_code,
          isBranchName: is_exist,
        };
      }
      return {
        ...state,
        isBranchName: is_exist,
        branchFetching: false,
        branchMessage: message,
        branchSatusCode: status_code,
        branchSuccess: success,
      };
    },
    [checkUniquePdfTemplateNameAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      branchFetching: false,
      branchSuccess: 0,
      error: error?.message,
    }),
    [updateMasterDataBranchAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [updateMasterDataBranchAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [updateMasterDataBranchAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),
    //Client Group;
    [createMasterClientGroupAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [createMasterClientGroupAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;
      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [createMasterClientGroupAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [getMasterDataClientGroupAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getMasterDataClientGroupAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, message, result, status_code, total_count } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        clientGroupList: result,
        success,
        clientGroupTotalCount: total_count,
      };
    },
    [getMasterDataClientGroupAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    [checkUniqueClientGroupNameAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      clientGroupUniqueCheckFetching: true,
    }),
    [checkUniqueClientGroupNameAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, message, status_code } = payload?.data;

      if (success === 0) {
        return {
          ...state,
          success: success,
          clientGroupUniqueCheckFetching: false,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        clientGroupUniqueCheckFetching: false,
        clientGroupUniqueCheckMessage: message,
        statusCode: status_code,
        success: success,
      };
    },
    [checkUniqueClientGroupNameAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      clientGroupUniqueCheckFetching: false,
      success: 0,
      error: error?.message,
    }),
    [updateMasterDataClientGroupAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [updateMasterDataClientGroupAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [updateMasterDataClientGroupAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [createMasterDataActivityCodeAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [createMasterDataActivityCodeAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message, result } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [createMasterDataActivityCodeAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [getMasterDataActivityCodeAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getMasterDataActivityCodeAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        masterDataActivivtyCodeListing: result,
        success,
      };
    },
    [getMasterDataActivityCodeAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    [updateMasterDataActivityCodeAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [updateMasterDataActivityCodeAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [updateMasterDataActivityCodeAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    // branch
    [getAllMasterDataBranchAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getAllMasterDataBranchAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { status_code, result, message, success, total_count } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        masterDataListing: result,
        statusCode: status_code,
        masterDataBranchListTotal: total_count,
      };
    },
    [getAllMasterDataBranchAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    // activity code
    [getAllMasterDataActivityCodeAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getAllMasterDataActivityCodeAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { status_code, result, message, success, total_count } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        masterDataActivivtyCodeListing: result,
        statusCode: status_code,
        masterDataActivityCodeListTotal: total_count,
      };
    },
    [getAllMasterDataActivityCodeAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    //  currency

    [createMasterDataCurrencyAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [createMasterDataCurrencyAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message, result } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [createMasterDataCurrencyAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [getMasterDataCurrencyAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getMasterDataCurrencyAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        masterDataCurrencyListing: result,
        success,
      };
    },
    [getMasterDataCurrencyAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    [updateMasterDataCurrencyAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [updateMasterDataCurrencyAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [updateMasterDataCurrencyAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [getAllMasterDataCurrencyAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getAllMasterDataCurrencyAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { status_code, result, message, success, total_count } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        masterDataCurrencyListing: result,
        statusCode: status_code,
        masterDataCurrencyListTotal: total_count,
      };
    },
    [getAllMasterDataCurrencyAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    // emailer
    [getMasterDataEmailersAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getMasterDataEmailersAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, message, result, status_code, total_count } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        emailerList: result,
        success,
        emailListTotalCount: total_count,
      };
    },
    [getMasterDataEmailersAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    //
    [createMasterEmailersAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [createMasterEmailersAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;
      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [createMasterEmailersAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [updateMasterDataEmailersAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [updateMasterDataEmailersAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [updateMasterDataEmailersAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    //  holiday

    [getMasterDataHolidayCalenderAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getMasterDataHolidayCalenderAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, message, result, status_code, total_count } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        holidayCalenderList: result,
        success,
        holidayCalenderTotalCount: total_count,
      };
    },
    [getMasterDataHolidayCalenderAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    [createMasterHolidayCalenderAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [createMasterHolidayCalenderAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;
      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [createMasterHolidayCalenderAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [updateMasterDataHolidayCalenderAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [updateMasterDataHolidayCalenderAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [updateMasterDataHolidayCalenderAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [deleteHolidayCalenderAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [deleteHolidayCalenderAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        message,
      };
    },
    [deleteHolidayCalenderAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error.message,
    }),

    [getAllCountryAction.pending.toString()]: (state: MasterDataType) => ({
      ...state,
      countryFetching: true,
    }),
    [getAllCountryAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, message, result, status_code, count } = payload;

      if (success === 0) {
        return {
          ...state,
          countryFetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        countryFetching: false,
        statusCode: status_code,
        countryList: result,
        success,
        countryListTotalCount: count ? count : 0,
      };
    },
    [getAllCountryAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      countryFetching: false,
      success: 0,
      error: error?.message,
    }),

    // state
    [getAllStateAction.pending.toString()]: (state: MasterDataType) => ({
      ...state,
      stateFetching: true,
    }),
    [getAllStateAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, message, result, status_code, count, is_state } =
        payload;

      if (success === 0) {
        return {
          ...state,
          stateFetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        stateFetching: false,
        statusCode: status_code,
        stateList: result,
        success,
        stateListTotalCount: count,
        isState: is_state,
      };
    },
    [getAllStateAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      stateFetching: false,
      success: 0,
      error: error?.message,
    }),

    // state permanent address
    [getAllStatePermanentAddressAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      stateFetchingPermanentAddress: true,
    }),
    [getAllStatePermanentAddressAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, message, result, status_code, count, is_state } =
        payload;

      if (success === 0) {
        return {
          ...state,
          stateFetchingPermanentAddress: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        stateFetchingPermanentAddress: false,
        statusCode: status_code,
        stateListPermanentAddress: result,
        success,
        stateListTotalCountPermanentAddress: count,
        isStatePermanentAddress: is_state,
      };
    },
    [getAllStatePermanentAddressAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      stateFetchingPermanentAddress: false,
      success: 0,
      error: error?.message,
    }),
    // city
    [getAllCityAction.pending.toString()]: (state: MasterDataType) => ({
      ...state,
      countryFetching: true,
    }),
    [getAllCityAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, message, result, status_code, count, is_city } = payload;

      if (success === 0) {
        return {
          ...state,
          countryFetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        countryFetching: false,
        statusCode: status_code,
        cityList: result,
        success,
        cityListTotalCount: count ? count : 0,
        isCity: is_city,
      };
    },
    [getAllCityAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      countryFetching: false,
      success: 0,
      error: error?.message,
    }),

    //  city permanent address
    [getAllCityPermanentAddressAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      cityFetchingPermanentAddress: true,
    }),
    [getAllCityPermanentAddressAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, message, result, status_code, count, is_city } = payload;

      if (success === 0) {
        return {
          ...state,
          cityFetchingPermanentAddress: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        cityFetchingPermanentAddress: false,
        statusCode: status_code,
        cityListPermanentAddress: result,
        success,
        cityListTotalCountPermanentAddress: count ? count : 0,
        isCityPermanentAddress: is_city,
      };
    },
    [getAllCityPermanentAddressAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      cityFetchingPermanentAddress: false,
      success: 0,
      error: error?.message,
    }),

    [getCurrencyExchangeAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      countryFetching: true,
    }),
    [getCurrencyExchangeAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          countryFetching: false,
          success,
          statusCode: status_code,
          error: message,
          currencyExchangeDetails: {
            date: "",
            baseCurrency: "",
            symbol: "",
            rate: "",
          },
        };
      }

      return {
        ...state,
        countryFetching: false,
        statusCode: status_code,
        currencyExchangeDetails: {
          date: result?.date,
          baseCurrency: result?.from,
          symbol: "",
          rate: result?.rate
            ? result?.rate?.toString()?.split(".")[1]?.length > 3
              ? result?.rate?.toFixed(3)
              : result?.rate
            : 1,
        },
        success,
      };
    },
    [getCurrencyExchangeAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      countryFetching: false,
      success: 0,
      error: error?.message,
    }),

    //  client category

    [getMasterDataClientCategoryAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getMasterDataClientCategoryAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, message, result, status_code, total_count } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        clientCategoryList: result,
        // success,
        clientCategoryTotalCount: total_count,
      };
    },
    [getMasterDataClientCategoryAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    [createMasterDataClientCategoryAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [createMasterDataClientCategoryAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;
      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [createMasterDataClientCategoryAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [updateMasterDataClientCategoryAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [updateMasterDataClientCategoryAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [updateMasterDataClientCategoryAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    //  User's Department
    [getMasterDataUsersDepartmentAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getMasterDataUsersDepartmentAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, message, result, status_code, total_count } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        userDepartmentList: result,
        userDepartmentTotalCount: total_count,
      };
    },
    [getMasterDataUsersDepartmentAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    [createMasterDataUsersDepartmentAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [createMasterDataUsersDepartmentAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;
      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [createMasterDataUsersDepartmentAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [updateMasterDataUsersDepartmentAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [updateMasterDataUsersDepartmentAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [updateMasterDataUsersDepartmentAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),
    [deleteMasterDataUsersDepartmentAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [deleteMasterDataUsersDepartmentAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [deleteMasterDataUsersDepartmentAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    //Tds Module
    //  User's Department
    [getMasterTdsModuleAction.pending.toString()]: (state: MasterDataType) => ({
      ...state,
      fetching: true,
    }),
    [getMasterTdsModuleAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, message, result, status_code, total_count } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        tdsDataList: result?.data,
        totalCount: result?.total_count,
      };
    },
    [getMasterTdsModuleAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [getMasterTdsModuleSingleAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getMasterTdsModuleSingleAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, message, result, status_code, total_count } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        tdsSingleData: result,
        totalCount: result?.total_count,
        message,
      };
    },
    [getMasterTdsModuleSingleAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [createMasterTdsModuleAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [createMasterTdsModuleAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;
      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [createMasterTdsModuleAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [updateMasterTdsModuleAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [updateMasterTdsModuleAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success: 0,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [updateMasterTdsModuleAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),
    [deleteMasterTdsModuleAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [deleteMasterTdsModuleAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [deleteMasterTdsModuleAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [getMasterDataSkillsModuleAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getMasterDataSkillsModuleAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, message, result, status_code, total_count } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        skillMasterDataList: result,
        skillsMasterDataTotalCount: total_count,
      };
    },
    [getMasterDataSkillsModuleAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    [createMasterDataSkillsModuleAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [createMasterDataSkillsModuleAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;
      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [createMasterDataSkillsModuleAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [updateMasterDataSkillsModuleAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [updateMasterDataSkillsModuleAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [updateMasterDataSkillsModuleAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),
    [deleteMasterDataSkillsAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [deleteMasterDataSkillsAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [deleteMasterDataSkillsAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),
    // Education module slice
    [getMasterDataQualificationModuleAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getMasterDataQualificationModuleAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, message, result, status_code, total_count } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        qualificationMasterDataList: result,
        qualificationMasterDataTotalCount: total_count,
      };
    },
    [getMasterDataQualificationModuleAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    [createMasterDataQualificationModuleAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [createMasterDataQualificationModuleAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;
      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [createMasterDataQualificationModuleAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [updateMasterDataQualificationModuleAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [updateMasterDataQualificationModuleAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [updateMasterDataQualificationModuleAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),
    [deleteMasterDataQualificationAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [deleteMasterDataQualificationAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [deleteMasterDataQualificationAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),
    // scope of work module
    [getMasterDataScopeOfWorkAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getMasterDataScopeOfWorkAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, message, result, status_code, total_count } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        scopeOfWorkList: result,
        scopeOfWorkTotalCount: total_count,
      };
    },
    [getMasterDataScopeOfWorkAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    [createMasterDataScopeOfWorkAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [createMasterDataScopeOfWorkAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;
      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [createMasterDataScopeOfWorkAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [updateMasterDataScopeOfWorkAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [updateMasterDataScopeOfWorkAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
          fetching: false,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [updateMasterDataScopeOfWorkAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [deleteMasterDataScopeOfWorkAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [deleteMasterDataScopeOfWorkAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
          fetching: false,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [deleteMasterDataScopeOfWorkAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),
    // TCS module slice
    [getMasterTcsModuleAction.pending.toString()]: (state: MasterDataType) => ({
      ...state,
      fetching: true,
    }),
    [getMasterTcsModuleAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, message, result, status_code, total_count } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        tcsDataList: result?.data,
        totalCount: result?.total_count,
      };
    },
    [getMasterTcsModuleAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [getMasterTcsModuleSingleAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getMasterTcsModuleSingleAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, message, result, status_code, total_count } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        tcsSingleData: result,
        totalCount: result?.total_count,
        message,
      };
    },
    [getMasterTcsModuleSingleAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [createMasterTcsModuleAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [createMasterTcsModuleAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;
      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [createMasterTcsModuleAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [updateMasterTcsModuleAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [updateMasterTcsModuleAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success: 0,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [updateMasterTcsModuleAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),
    [deleteMasterTcsModuleAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [deleteMasterTcsModuleAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [deleteMasterTcsModuleAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),
    /////code unique check
    [checkUniqueCode.pending.toString()]: (state: MasterDataType) => ({
      ...state,
      codeFetching: true,
    }),
    [checkUniqueCode.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          success: success,
          codeFetching: false,

          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        codeFetching: false,
        codeMessage: message,
        statusCode: status_code,
        success: success,
      };
    },
    [checkUniqueCode.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      codeFetching: false,
      success: 0,
      error: error?.message,
    }),
    //pdf Template
    [getMasterPdfTemplateListAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getMasterPdfTemplateListAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, message, result, status_code, total_count } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        pdfTemplateList: result?.data,
        pdfTemplateCount: result?.total_count,
      };
    },
    [getMasterPdfTemplateListAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [createMasterPdfTemplateAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [createMasterPdfTemplateAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;
      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [createMasterPdfTemplateAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [updateMasterPdfTemplateAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [updateMasterPdfTemplateAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success: 0,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [updateMasterPdfTemplateAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),
    [deleteMasterPdfTemplateAction.pending.toString()]: (
      state: MasterDataType
    ) => ({
      ...state,
      fetching: true,
    }),
    [deleteMasterPdfTemplateAction.fulfilled.toString()]: (
      state: MasterDataType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          fetching: false,
          message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [deleteMasterPdfTemplateAction.rejected.toString()]: (
      state: MasterDataType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),
  },
});
export const {
  resetMasterError,
  resetMasterSuccess,
  resetMasterMessage,
  resetMasterFetching,
  resetMasterDataActivivtyCodeListing,
  resetMasterDataCurrencyListing,
  resetMasterDataLisitng,
  resetMasterDataActivityCodeListTotal,
  resetMasterDataCurrencyListTotal,
  resetMasterDataBranchListTotal,
  resetBranchSuccess: resetBranchSatusCode,
  resetBranchError,
  resetBranchMessage,
  resetIsBranchName,
  resetBranchFetching,
  resetClientGroupList,
  resetClientGroupTotalCount,
  resetEmailerList,
  resetEmailListTotalCount,
  resetClientGroupUniqueCheckMessage,
  resetClientGroupUniqueCheckFetching,
  resetMasterStatusCode,
  resetCountryList,
  resetCountryListTotalCount,
  resetHolidayCalenderList,
  resetHolidayCalenderTotalCount,
  resetStateList,
  resetStateListTotalCount,
  resetStateFetching,
  resetCityList,
  resetCityListTotalCount,
  resetCityFetching,
  resetCurrencyExchangeDetails,
  resetStateListAddressPermanent,
  resetCityListPermanentAddress,
  resetClientCategoryList,
  resetClientCategoryTotalCount,
  resetUserDepartmentList,
  resetUserDepartmentTotalCount,
  resetTdsModuleList,
  resetTotalCount,
  resetTdsSingleData,
  resetScopeOfWorkList,
  resetScopeTotalCount,
  resetSkillsMasterDataTotalCount,
  resetSkillMasterDataList,
  resetQualificationMasterDataList,
  resetQualificationMasterDataTotalCount,
  resetTcsSingleData,
  resetTcsModuleList,
  setPersistApplicationInProgess,
  setPersistOfferAccepted,
  resetCodeFetching,
  resetCodeError,
  resetCodeMessage,
  resetPdfTemplate,
  resetPdfTemplateCount,
} = masterDataSlice.actions;
